/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/common';
import * as i2 from '../../../app/components/change-class-form';
import * as i3 from '@ngrx/store/src/store';
import * as i4 from '@ngrx/effects/src/actions';
import * as i5 from '../../../app/services/modal';
const styles_ChangeClassFormComponent:any[] = ([] as any[]);
export const RenderType_ChangeClassFormComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_ChangeClassFormComponent,data:{}});
function View_ChangeClassFormComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),5,'li',[['class',
      'ccf__potential']],(null as any),[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.clickedClass(_v.context.$implicit)) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),i0.ɵdid(1,278528,(null as any),0,i1.NgClass,[i0.IterableDiffers,
      i0.KeyValueDiffers,i0.ElementRef,i0.Renderer],{klass:[0,'klass'],ngClass:[1,
      'ngClass']},(null as any)),i0.ɵpod(2,{'selected':0}),(_l()(),i0.ɵted(3,(null as any),
      ['',''])),(_l()(),i0.ɵeld(4,0,(null as any),(null as any),1,'label',[['class',
      'ccf__current-enrolments']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵted(5,(null as any),['Spots taken: ','']))],(_ck,
      _v) => {
    var _co:any = _v.component;
    const currVal_0:any = 'ccf__potential';
    const currVal_1:any = _ck(_v,2,0,_co.isClassSelected(_v.context.$implicit));
    _ck(_v,1,0,currVal_0,currVal_1);
  },(_ck,_v) => {
    const currVal_2:any = _v.context.$implicit.code;
    _ck(_v,3,0,currVal_2);
    const currVal_3:any = _v.context.$implicit.getEffectiveEnrolmentsCount();
    _ck(_v,5,0,currVal_3);
  });
}
export function View_ChangeClassFormComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),14,'div',[['class',
      'change-class-form']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵeld(1,0,(null as any),(null as any),13,'div',[['class',
      'ccf__content-wrapper']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵeld(2,0,(null as any),(null as any),1,'h1',[['class',
      'ccf__header']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted(-1,(null as any),['Change class'])),(_l()(),i0.ɵeld(4,0,(null as any),
          (null as any),1,'div',[['class','ccf__blurb']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i0.ɵted(-1,(null as any),
          ['Select a Class to switch this Enrolment to...'])),(_l()(),i0.ɵeld(6,0,
          (null as any),(null as any),3,'div',[['class','ccf__potentials-wrapper']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(7,0,(null as any),(null as any),2,'ul',[['class','ccf__potentials']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ChangeClassFormComponent_1)),
      i0.ɵdid(9,802816,(null as any),0,i1.NgForOf,[i0.ViewContainerRef,i0.TemplateRef,
          i0.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i0.ɵeld(10,
          0,(null as any),(null as any),4,'div',[['class','ccf__actions']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵeld(11,
          0,(null as any),(null as any),3,'div',[['class','input-group']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵeld(12,
          0,(null as any),(null as any),2,'div',[['class','ig__content-wrapper']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(13,0,(null as any),(null as any),1,'button',([] as any[]),(null as any),
          [[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i2.ChangeClassFormComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.clickedChangeClass()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i0.ɵted(-1,(null as any),['Change class']))],
      (_ck,_v) => {
        var _co:i2.ChangeClassFormComponent = _v.component;
        const currVal_0:any = _co.getFilteredPotentialClasses();
        _ck(_v,9,0,currVal_0);
      },(null as any));
}
export function View_ChangeClassFormComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'change-class-form',
      ([] as any[]),(null as any),(null as any),(null as any),View_ChangeClassFormComponent_0,
      RenderType_ChangeClassFormComponent)),i0.ɵdid(1,245760,(null as any),0,i2.ChangeClassFormComponent,
      [i3.Store,i4.Actions,i5.ModalService],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const ChangeClassFormComponentNgFactory:i0.ComponentFactory<i2.ChangeClassFormComponent> = i0.ɵccf('change-class-form',
    i2.ChangeClassFormComponent,View_ChangeClassFormComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/$$_gendir/app/components/change-class-form.ngfactory.ts